module.exports = __webpack_public_path__ + "img/green.801b5172.svg";